import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/shared/ui/button';

/** Rendered for unmatched routes. */
export function NotFound(){
  return (
    <div className="flex flex-col items-center justify-center gap-4 p-8" role="main">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-muted-foreground">Die angeforderte Seite wurde nicht gefunden.</p>
      <Button asChild>
        <Link to="/">Zur Startseite</Link>
      </Button>
    </div>
  );
}
